import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService, LocalStorageService } from 'src/app/core/core.module';
import { FundsPortalService } from 'src/app/core/services/funds-portal.service';
import { AtramModalComponent } from 'src/app/shared/components/atram-modal/atram-modal.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-otp-log-in-page',
  templateUrl: './otp-log-in-page.component.html',
  styleUrls: ['./otp-log-in-page.component.less']
})
export class OtpLogInPageComponent implements OnInit {
  
  @ViewChild('atramModal')
  public atramModal: AtramModalComponent = new AtramModalComponent;

  public searchFormGroup!: FormGroup; 

  public openNav: boolean = false;
  public resendOTP: boolean = false;
  public isError: boolean = false;
  public isInvalidCode: boolean = false;
  public isNotValidInputs: boolean = false;
  public countDown: number = 60;
  public countDownTracker: string = "";
  public otpCode: string = "";
  public mobileNo: string = "";
  public invalidText: string = "";
  
  constructor(
    public fundsPortalService: FundsPortalService,
    public router: Router,
    public localStorageService: LocalStorageService,
    public authService: AuthService
  ) { 
    
  }

  ngOnInit(): void {
    this.initializeFormGroup();
    this.timerNotice();
  }


  //#region Form Group Events
  initializeFormGroup(): void {
    this.searchFormGroup = new FormGroup({
      // expiryDate: new FormControl('', [Validators.required]),
      otp: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required])
    });
  }

  //#region service calls

  onOtpChange(e:any){
    this.searchFormGroup.get('otp')?.setValue(e);
    if(this.searchFormGroup.get('otp')?.value.length == 6)
      this.isError = false;    
  }

  proceed(): void{
    if(this.searchFormGroup.get('otp')?.value.length < 6){
      this.isError = true;
      this.isNotValidInputs = true;
    }
    else{
      this.isNotValidInputs = false;
      this.submit();
    }
  }

  submit(): Promise<any> {
    // if(this.searchFormGroup.get('otpCode')?.value == '' || ){

    // }
    let body = {  
        otp : this.searchFormGroup.get('otp')?.value
    }

    return new Promise<any>((resolve: any, reject: any) => {
      this.authService.postValidateLogin(body)
      .subscribe({
        next: (data:any) =>{
          resolve(data);
          if (data['response_result'] === '0001'){
            localStorage.clear();
            this.localStorageService.set('authorized', '0001',data['response_data']['expires_in']);
            this.localStorageService.set('bearer', data['response_data']['access_token'],data['response_data']['expires_in']);
            this.localStorageService.set('companyCode',data['companyCode'],data['response_data']['expires_in']);
            this.router.navigateByUrl(`/file-upload/mutual-funds`, { skipLocationChange: false });
            return;
          }
        },
        error: error =>{
          if(!error['response_data'].includes('out of 5')){
            this.atramModal.show();
            this.atramModal.size = 'sm';
            this.atramModal.status = 'error';
            this.atramModal.headerText = 'OTP Expired';
            this.atramModal.bodyText = 'Please click on "Resend OTP" to receive a new code.';
            this.atramModal.okButtonText = 'Resend OTP'; 
            this.atramModal.showCancelButton = false;
            this.atramModal.showCloseButton = false;
            this.atramModal.confirmationSubject
              .subscribe((confirmation: boolean) => {
                if (confirmation) {
                  this.resendOTPCode();
                } else {
                  // Cancel
                }
                this.atramModal.hide();
              });
          }
          else if(error['response_data'].includes('out of 5') && !error['response_data'].includes('5 out of 5')){
            this.isInvalidCode = true;
            this.invalidText = error['response_data'];
          }
          else if(error['response_data'].includes('5 out of 5')){
            this.isInvalidCode = false;
            this.atramModal.show();
            this.atramModal.size = 'sm';
            this.atramModal.status = 'error';
            this.atramModal.headerText = 'Account Locked';
            this.atramModal.bodyText ='Your account was locked due to exceeded incorrect OTP attempts. Instruction has been sent to your registered email address to reset your password. ';
            this.atramModal.okButtonText = 'Return to sign-in'; 
            this.atramModal.showCancelButton = false;
            this.atramModal.showCloseButton = false;
            this.atramModal.confirmationSubject
              .subscribe((confirmation: boolean) => {
                if (confirmation) {
                  this.atramModal.hide();
                  let body = {  
                      email: this.localStorageService.get('email'),
                      redirect_link: environment.URL+'/forgot-password/change-password'
                    }
                    this.fundsPortalService.postForgotPassword(body)
                    .subscribe({
                      next: (data:any) =>{
                        resolve(data);
                        this.router.navigateByUrl(``, { skipLocationChange: false });
                      },
                      error: error =>{
                        this.atramModal.show();
                          this.atramModal.size = 'sm';
                          this.atramModal.status = 'error';
                          this.atramModal.headerText = 'Internal Error';
                          this.atramModal.bodyText = error['response_data'];
                          this.atramModal.okButtonText = 'Go To Sign-in';
                          this.atramModal.showCancelButton = false;
                          this.atramModal.showCloseButton = false;
                          this.atramModal.confirmationSubject
                            .subscribe((confirmation: boolean) => {
                              if (confirmation) {
                                this.router.navigateByUrl(``, { skipLocationChange: false });
                                // OK
                              } else {
                                // Cancel
                              }
                              this.atramModal.hide();
                            });
                          return;
                      }
                    })
                } else {
                  // Cancel
                }
                this.atramModal.hide();
              });
          }
        }
      })
    });
  }

  resendOTPCode(): Promise<any>{
    return new Promise<any>((resolve: any, reject: any) => {
      this.authService.postResendLoginOTP()
      .subscribe({
        next: (data:any) =>{
          resolve(data);
          if (data['response_result'] === '0001'){
            this.resendOTP = false;
            this.countDown = 60;
            this.timerNotice();
            return;
          }
        },
        error: error =>{
          this.atramModal.show();
          this.atramModal.size = 'sm';
          this.atramModal.status = 'error';
          this.atramModal.headerText = 'OTP Resend Failed';
          this.atramModal.bodyText = 'Internal Error';
          this.atramModal.okButtonText = 'Return';
          this.atramModal.showCancelButton = false;
          this.atramModal.showCloseButton = false;
          this.atramModal.confirmationSubject
            .subscribe((confirmation: boolean) => {
              if (confirmation) {
                // OK
              } else {
                // Cancel
              }
              this.atramModal.hide();
            });
        }
      })
    });
  }

  timerNotice(){
    if(this.countDown >= 0){
      setTimeout(() => {
        if(this.countDown >= 10){
          this.countDownTracker = "00:" + this.countDown.toLocaleString();
        }
        else
        this.countDownTracker = "00:0" + this.countDown.toLocaleString();
        this.countDown--;
        this.timerNotice();
      }, 1000);
    }

    else{
      this.countDown = 60;
      this.resendOTP = true;
    }
  }

  goToSignIn(){
    this.router.navigateByUrl(``, { skipLocationChange: false });
  }
}
